/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import UiFormInner from 'components/Forms/UIFormInner'
import CompanyActivityLog from 'components/Companies/ActivityLog/CompanyActivityLog'
import { Company } from 'types/entities/Company'

interface EditCompanyModalActivityTabProps {
    company: Company
}

const EditCompanyModalActivityTab = ({ company }: EditCompanyModalActivityTabProps) => {
    const { t } = useTranslation()

    return (
        <div className={clsx('EditCompanyModalActivityTab flex-1 flex flex-col pt-4 overflow-hidden')}>
            <UiFormInner title={t('Activity Log')}>
                <CompanyActivityLog company={company} />
            </UiFormInner>
        </div>
    )
}

export default EditCompanyModalActivityTab
